// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment-_EQEf";
var _3 = "label-3CUU7";
export { _1 as "__esModule", _2 as "segment", _3 as "label" }
export default { "__esModule": _1, "segment": _2, "label": _3 }
